module.exports = __webpack_public_path__ + "img/kumamon.de3002f6.png";